// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ComputeProductOfferingConfigCostsQueryVariables = Types.Exact<{
  input: Types.ProductOfferingConfigCostsInput;
}>;


export type ComputeProductOfferingConfigCostsQuery = { __typename?: 'Query', computeProductOfferingConfigCosts: { __typename?: 'ComputeProductOfferingConfigCostsResult', configCosts: Array<{ __typename?: 'ConfigCostsResult', productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, name: string, totalCostInCents: number, isBaseConfig: boolean, productOffering: { __typename?: 'ProductOffering', id: string, name: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, stories?: number | null | undefined, garageAttached?: number | null | undefined, garageDetached?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, imperviousSqft?: number | null | undefined, minLotSizeInSqft?: number | null | undefined, minLotWidthInFeet?: number | null | undefined, minLotDepthInFeet?: number | null | undefined } }, computedOptionCosts: Array<{ __typename?: 'ReadyPlanOptionConfigCosts', totalCostInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, order: number, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, forDesignInterior: boolean, forDesignExterior: boolean }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, isSingleOptionGroup: boolean } } }> }> } };

export type ConfigsComparePage_ConfigCostsFragment = { __typename?: 'ConfigCostsResult', productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, name: string, totalCostInCents: number, isBaseConfig: boolean, productOffering: { __typename?: 'ProductOffering', id: string, name: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, stories?: number | null | undefined, garageAttached?: number | null | undefined, garageDetached?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, imperviousSqft?: number | null | undefined, minLotSizeInSqft?: number | null | undefined, minLotWidthInFeet?: number | null | undefined, minLotDepthInFeet?: number | null | undefined } }, computedOptionCosts: Array<{ __typename?: 'ReadyPlanOptionConfigCosts', totalCostInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, order: number, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, forDesignInterior: boolean, forDesignExterior: boolean }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, isSingleOptionGroup: boolean } } }> };

export type ConfigsComparePage_ConfigFragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, totalCostInCents: number, isBaseConfig: boolean, productOffering: { __typename?: 'ProductOffering', id: string, name: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }, programData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, stories?: number | null | undefined, garageAttached?: number | null | undefined, garageDetached?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, imperviousSqft?: number | null | undefined, minLotSizeInSqft?: number | null | undefined, minLotWidthInFeet?: number | null | undefined, minLotDepthInFeet?: number | null | undefined } };

export type ConfigsComparePage_OptionConfigCostsFragment = { __typename?: 'ReadyPlanOptionConfigCosts', totalCostInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, displayName: string, order: number, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, forDesignInterior: boolean, forDesignExterior: boolean }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, isSingleOptionGroup: boolean } } };

export type ConfigsComparePage_ProgramDataFragment = { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, stories?: number | null | undefined, garageAttached?: number | null | undefined, garageDetached?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined, imperviousSqft?: number | null | undefined, minLotSizeInSqft?: number | null | undefined, minLotWidthInFeet?: number | null | undefined, minLotDepthInFeet?: number | null | undefined };

export const ConfigsComparePage_ProgramDataFragmentDoc = gql`
    fragment ConfigsComparePage_ProgramData on ProgramData {
  id
  sellableSqft
  bedrooms
  fullBaths
  halfBaths
  stories
  garageAttached
  garageDetached
  widthInFeet
  depthInFeet
  imperviousSqft
  minLotSizeInSqft
  minLotWidthInFeet
  minLotDepthInFeet
}
    `;
export const ConfigsComparePage_ConfigFragmentDoc = gql`
    fragment ConfigsComparePage_Config on ProductOfferingConfig {
  id
  name
  totalCostInCents
  isBaseConfig
  productOffering {
    id
    name
    coverAsset {
      id
      previewUrl(resizing: {width: 321, region: FULL})
    }
  }
  programData {
    ...ConfigsComparePage_ProgramData
  }
}
    ${ConfigsComparePage_ProgramDataFragmentDoc}`;
export const ConfigsComparePage_OptionConfigCostsFragmentDoc = gql`
    fragment ConfigsComparePage_OptionConfigCosts on ReadyPlanOptionConfigCosts {
  readyPlanOption {
    id
    type {
      id
      name
      order
      forDesignInterior
      forDesignExterior
    }
    displayName
    optionGroup {
      id
      name
      order
      isSingleOptionGroup
    }
    order
  }
  totalCostInCents
}
    `;
export const ConfigsComparePage_ConfigCostsFragmentDoc = gql`
    fragment ConfigsComparePage_ConfigCosts on ConfigCostsResult {
  productOfferingConfig {
    ...ConfigsComparePage_Config
  }
  computedOptionCosts {
    ...ConfigsComparePage_OptionConfigCosts
  }
}
    ${ConfigsComparePage_ConfigFragmentDoc}
${ConfigsComparePage_OptionConfigCostsFragmentDoc}`;
export const ComputeProductOfferingConfigCostsDocument = gql`
    query ComputeProductOfferingConfigCosts($input: ProductOfferingConfigCostsInput!) {
  computeProductOfferingConfigCosts(input: $input) {
    configCosts {
      ...ConfigsComparePage_ConfigCosts
    }
  }
}
    ${ConfigsComparePage_ConfigCostsFragmentDoc}`;

/**
 * __useComputeProductOfferingConfigCostsQuery__
 *
 * To run a query within a React component, call `useComputeProductOfferingConfigCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeProductOfferingConfigCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeProductOfferingConfigCostsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComputeProductOfferingConfigCostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables> & ({ variables: ComputeProductOfferingConfigCostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>(ComputeProductOfferingConfigCostsDocument, options);
      }
export function useComputeProductOfferingConfigCostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>(ComputeProductOfferingConfigCostsDocument, options);
        }
// @ts-ignore
export function useComputeProductOfferingConfigCostsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>;
export function useComputeProductOfferingConfigCostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ComputeProductOfferingConfigCostsQuery | undefined, ComputeProductOfferingConfigCostsQueryVariables>;
export function useComputeProductOfferingConfigCostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>(ComputeProductOfferingConfigCostsDocument, options);
        }
export type ComputeProductOfferingConfigCostsQueryHookResult = ReturnType<typeof useComputeProductOfferingConfigCostsQuery>;
export type ComputeProductOfferingConfigCostsLazyQueryHookResult = ReturnType<typeof useComputeProductOfferingConfigCostsLazyQuery>;
export type ComputeProductOfferingConfigCostsSuspenseQueryHookResult = ReturnType<typeof useComputeProductOfferingConfigCostsSuspenseQuery>;
export type ComputeProductOfferingConfigCostsQueryResult = Apollo.QueryResult<ComputeProductOfferingConfigCostsQuery, ComputeProductOfferingConfigCostsQueryVariables>;